import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
export const LocalConfig = createContext({});
export const useConfig = () => useContext(LocalConfig);
export const LocalConfigProvider = ({ children }) => {
    const [apiConfig, setApiConfig] = useState();
    const [microfrontendsConfig, setMicrofrontendsConfig] = useState();
    const [platform, setPlatform] = useState();
    useEffect(() => {
        setMicrofrontendsConfig(window.MICROFRONTENDS_CONFIG);
        window.GET_API_CONFIG().then(setApiConfig);
        setPlatform(window.PLATFORM);
    }, []);
    return (_jsx(LocalConfig.Provider, { value: { appApi: apiConfig, microfrontends: microfrontendsConfig, platform }, children: microfrontendsConfig && apiConfig && children }));
};
export const useConfigApiBaseUrl = () => {
    const { appApi: { API_HOST: baseUrl } = {} } = useConfig();
    return `${baseUrl}${(baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.includes('localhost')) ? '/' : ''}`;
};
//# sourceMappingURL=LocalConfigProvider.js.map